var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouthEngement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 36L8 28.4V16.4L0 12L22 0L44 12V28H40V14.2L36 16.4V28.4L22 36V36M22 19.4L35.7 12L22 4.6L8.3 12L22 19.4V19.4M22 31.45L32 26.05V18.5L22 24L12 18.5V26.05L22 31.45V31.45M22 19.4V19.4V19.4V19.4V19.4V19.4M22 23.9V23.9V23.9V23.9V23.9V23.9V23.9V23.9V23.9V23.9M22 23.9V23.9V23.9V23.9V23.9V23.9V23.9V23.9V23.9V23.9",
    fill: "#FDC82A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouthEngement);
export default __webpack_public_path__ + "static/media/youth-engement.5195a9bddb0cff3008c04baec0c16cfe.svg";
export { ForwardRef as ReactComponent };